import { useRef as l, useCallback as o } from "react";
function c(n, u = 300, r = {}) {
  const e = l(null), i = o(
    (t) => {
      e.current ? (clearTimeout(e.current), e.current = null, n && n(t)) : e.current = setTimeout(() => {
        r.onSingleTap && r.onSingleTap(t), e.current = null;
      }, u);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n, u, r.onSingleTap]
  );
  return n ? {
    onClick: i
  } : {};
}
export {
  c as useDoubleTap
};
